/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit OtherBoardsIcon/view.blocks to change it.
import React from 'react'
import Tysiav2TaskOtherBoardsIcon from 'DesignSystem/Svgs/Tysiav2TaskOtherBoardsIcon/index'



/** @type {import('Simple/types.js').View} */
export default function OtherBoardsIcon({
  children,
  viewPath = "/DesignSystem/TasksBoardsList/Boards/Content/Header/Content/Content/No/BoardListIcon/OtherBoardsIcon"
  
}) {
  return (<React.Fragment
>
<Tysiav2TaskOtherBoardsIcon
  viewPath={`${viewPath}/Tysiav2TaskOtherBoardsIcon`}
/>
{children}
</React.Fragment>)
}